import { Tooltip } from 'antd';
import classNames from 'classnames';
import * as clipboard from 'clipboard-polyfill/text';
import { stubString } from 'lodash-es';
import { FormattedMessage } from 'react-intl';

import { FATypes } from '../adapters/fontAwesomeAdapters';
import IconButton from '../buttons/IconButton';
import { useFlashMessageContext } from '../dialogs/FlashMessageProvider';
import { useTooltipStyles } from '../../styles/tooltip.styles';
import { useCopyToClipboardStyles } from './CopyToClipboard.styles';

export function CopyToClipboardHoverArea({
  className,
  alwaysVisible,
  ...rest
}) {
  const { styles } = useCopyToClipboardStyles();
  return (
    <div
      className={classNames(
        alwaysVisible
          ? styles.copyToClipboardHoverAreaAlwaysVisible
          : styles.copyToClipboardHoverAreaShowOnHover,
        className
      )}
      {...rest}
    />
  );
}

export function CopyToClipboardButton({
  className,
  iconWrapperClassName,
  tooltip,
  tooltipId,
  getContent = stubString,
}) {
  const { errorMessage, successMessage } = useFlashMessageContext();
  const { styles } = useCopyToClipboardStyles();
  const { styles: tooltipStyles } = useTooltipStyles();

  const tooltipContent = tooltipId ? (
    <FormattedMessage id={tooltipId} />
  ) : (
    tooltip
  );

  return (
    <Tooltip
      title={tooltipContent || <FormattedMessage id="buttons.copy" />}
      placement="bottom"
      classNames={{
        root: `${styles.tooltipWithNoArrow} ${tooltipStyles.sm}`,
      }}
    >
      <span
        className={classNames(
          'CopyToClipboard-Icon',
          styles.copyToClipboardIcon,
          iconWrapperClassName
        )}
      >
        <IconButton
          icon="copy"
          type={FATypes.REGULAR}
          className={className}
          onClick={async e => {
            e.stopPropagation();
            try {
              clipboard.writeText(getContent());
              successMessage({ contentId: 'copyToClipboard.success' });
            } catch (err) {
              errorMessage({ contentId: 'copyToClipboard.failure' });
            }
          }}
        />
      </span>
    </Tooltip>
  );
}
